<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <span class="title-icon" [style.--k-bg]="corSelecionada()?.corFundo"
      [style.--k-bg-dark]="corSelecionada()?.corFundoDark" [style.--k-fg]="corSelecionada()?.corConteudo"
      [style.--k-fg-dark]="corSelecionada()?.corConteudoDark">
      <mat-icon class="material-symbols-outlined">{{ iconeNomeSelecionado() }}</mat-icon>
    </span>
  </div>
  <div class="modal-header-titles">
    <div class="modal-eyebrow">{{ isEdicao ? 'EDITAR ETAPA' : 'NOVA ETAPA' }}</div>
    <div class="modal-title-row">
      <h2 class="modal-title">{{ nome || 'Informe o nome da etapa' }}</h2>
      <span class="status-badge badge-cinza">
        <span class="material-symbols-outlined">{{ data.tipoIcones[data.idTipoProcessoKanban] }}</span>
        {{ data.tipoNome }}
      </span>
    </div>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content" [style.--k-bg]="corSelecionada()?.corFundo"
  [style.--k-bg-dark]="corSelecionada()?.corFundoDark" [style.--k-fg]="corSelecionada()?.corConteudo"
  [style.--k-fg-dark]="corSelecionada()?.corConteudoDark">

  <!-- 1. Identidade -->
  <section class="kb-secao">
    <div class="section-title">
      <span class="status-badge badge-cinza">1</span>
      <mat-icon class="material-symbols-outlined">badge</mat-icon>
      <span>Identidade</span>
    </div>
    <p class="section-sub-title">Como esta etapa aparece no board operacional.</p>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nome da etapa</mat-label>
      <input matInput [(ngModel)]="nome" [disabled]="isFixo" placeholder="Ex.: Em aberto" maxlength="60">
      @if (isFixo) {
      <mat-icon matSuffix class="material-symbols-outlined nome-lock" matTooltip="Nome fixo do sistema">lock</mat-icon>
      }
    </mat-form-field>

    <div class="grid-2">
      <div class="caixa-escolha cor">
        <label class="kb-secao-label">Cor</label>
        <div class="grid-cores">
          @for (c of data.cores; track c.idKanbanCor) {
          <!-- O botão inteiro é a cor (protótipo): quadrado de 32px preenchido, sem bolinha interna. -->
          <button type="button" class="btn-cor" [class.sel]="idKanbanCor === c.idKanbanCor"
            (click)="selecionarCor(c.idKanbanCor)" [matTooltip]="c.nome"
            [style.--dot-l]="corPorId(c.idKanbanCor)?.corPrincipal"
            [style.--dot-d]="corPorId(c.idKanbanCor)?.corPrincipalDark"></button>
          }
        </div>
      </div>

      <div class="caixa-escolha icone">
        <label class="kb-secao-label">Ícone</label>
        <div class="grid-icones">
          @for (ic of data.icones; track ic.idKanbanIcone) {
          <button type="button" class="btn-icone" [class.sel]="idKanbanIcone === ic.idKanbanIcone"
            (click)="selecionarIcone(ic.idKanbanIcone)" [matTooltip]="ic.nomeIcone">
            <!-- cor do selecionado vem das CSS vars (--k-bg/--k-fg) definidas no modal -->
            <mat-icon class="material-symbols-outlined">{{ ic.nomeIcone }}</mat-icon>
          </button>
          }
        </div>
      </div>
    </div>
  </section>

  <!-- A nota da etapa fixa vem logo após a Identidade (protótipo): ela explica por que as
       demais seções estão ausentes ou travadas, então precisa ser lida antes delas. Vale para
       todos os tipos de etapa fixa — etapa do fluxo, especial e marcador de envio e retirada. -->
  @if (isFixo) {
  <div class="nota-fixo-wrap">
    <app-alert-card type="neutral" icon="lock">{{ notaEtapaFixa }}</app-alert-card>
  </div>
  }

  @if (mostraSecoesDeFluxo) {
  <!-- 2. Papel no fluxo -->
  <section class="kb-secao">
    <div class="section-title">
      <span class="status-badge badge-cinza">2</span>
      <mat-icon class="material-symbols-outlined">flag_circle</mat-icon>
      <span>Papel no fluxo</span>
    </div>
    <p class="section-sub-title">Define onde o card nasce e onde ele é encerrado neste processo.</p>

    <!-- Padrão do design system (ver Devoluções de Vendas): switch à esquerda do rótulo,
         dentro do próprio mat-slide-toggle; texto de apoio abaixo, indentado sob o rótulo. -->
    <div class="toggle-content">
      <mat-slide-toggle class="app-toggle-compact" [checked]="isInicial" (change)="onInicialChange($event.checked)">
        <mat-icon class="material-symbols-outlined toggle-label-icon">play_circle</mat-icon> Etapa inicial
      </mat-slide-toggle>
      <span class="info-text">Onde o card nasce neste processo (apenas 1 por processo).</span>
    </div>
    <div class="toggle-content">
      <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="isFinal">
        <mat-icon class="material-symbols-outlined toggle-label-icon">flag</mat-icon> Etapa final
      </mat-slide-toggle>
      <span class="info-text">Encerra o card — pode haver vários.</span>
    </div>
  </section>
  }

  <!-- Visibilidade dos cards -->
  <section class="kb-secao">
    <div class="section-title">
      <span class="status-badge badge-cinza">{{ numeroSecaoVisibilidade }}</span>
      <mat-icon class="material-symbols-outlined">visibility</mat-icon>
      <span>Visibilidade dos cards</span>
    </div>
    <p class="section-sub-title">Quem enxerga esta etapa e os cards que estão nela.</p>

    <mat-radio-group [(ngModel)]="visibilidadeTodos" class="vis-radios">
      <mat-radio-button [value]="true">Todos os perfis</mat-radio-button>
      <mat-radio-button [value]="false">Perfis específicos</mat-radio-button>
    </mat-radio-group>
    @if (!visibilidadeTodos) {
    <app-select-pesquisavel [control]="visibilidadeControl" label="Perfis que podem visualizar esta etapa"
      [offlineList]="data.perfis" idField="idPerfil" nameField="nome" [multiple]="true" [showBadges]="true"
      subscriptSizing="dynamic">
    </app-select-pesquisavel>
    <div class="hint">Lista vazia = todos os perfis podem visualizar.</div>
    }

    <!-- Segunda camada de visibilidade: a restrição de carteira do vendedor. -->
    <app-alert-card type="info">
      Além desta configuração, o vendedor com restrição de carteira vê apenas os próprios documentos, mesmo em
      etapa liberada para o seu perfil. Essa restrição é definida no cadastro do vendedor.
    </app-alert-card>
  </section>

  @if (mostraSecoesDeFluxo) {
  <!-- 4. Movimentações permitidas -->
  <section class="kb-secao">
    <div class="section-title">
      <span class="status-badge badge-cinza">4</span>
      <mat-icon class="material-symbols-outlined">route</mat-icon>
      <span>Movimentações permitidas</span>
    </div>
    <p class="section-sub-title">A partir de {{ nome || 'esta etapa' }}, o card pode ir para {{ qtdMovimentacoes }} destino(s).</p>

    @for (grupo of gruposDestino; track grupo.processo.idConfigKanbanProcesso) {
    <div class="grupo-processo">
      <div class="grupo-titulo">
        <mat-icon class="material-symbols-outlined">{{ data.tipoIcones[grupo.processo.idTipoProcessoKanban]
          }}</mat-icon>
        {{ grupo.processo.descricaoTipo }}
        @if (grupo.isOutroProcesso) { <span class="outro-proc"><mat-icon
            class="material-symbols-outlined">alt_route</mat-icon> outro processo</span> }
      </div>

      @for (d of grupo.destinos; track d.etapa.idEtapaKanban) {
      <div class="transicao" [class.sel]="isDestino(d.etapa.idEtapaKanban)">
        <!-- O <label> propaga o clique de qualquer ponto da linha para o checkbox,
             independente da posição dele dentro do label (mesmo padrão do Kanban de Compras). -->
        <label class="transicao-head">
          <mat-checkbox color="primary" [checked]="isDestino(d.etapa.idEtapaKanban)"
            (change)="toggleDestino(d.etapa.idEtapaKanban, $event.checked)"></mat-checkbox>
          <!-- Ícone da etapa na própria cor, como no protótipo (não uma bolinha). -->
          <span class="dest-icone" [style.--k-bg]="corPorId(d.etapa.idKanbanCor)?.corFundo"
            [style.--k-bg-dark]="corPorId(d.etapa.idKanbanCor)?.corFundoDark"
            [style.--k-fg]="corPorId(d.etapa.idKanbanCor)?.corConteudo"
            [style.--k-fg-dark]="corPorId(d.etapa.idKanbanCor)?.corConteudoDark">
            <mat-icon class="material-symbols-outlined">{{ iconeNome(d.etapa.idKanbanIcone) }}</mat-icon>
          </span>
          <span class="transicao-nome">{{ d.etapa.nome }}</span>
          @if (d.isEspecial) {
          <span class="mini-badge especial" matTooltip="Etapa especial: encerra o card fora do fluxo linear.">
            <mat-icon class="material-symbols-outlined">auto_awesome</mat-icon> especial
          </span>
          }
          @if (d.etapa.isFinal) { <span class="mini-badge">final</span> }
        </label>
        @if (isDestino(d.etapa.idEtapaKanban)) {
        <div class="transicao-perfis">
          <span class="perfis-mover-label">
            <mat-icon class="material-symbols-outlined">lock_person</mat-icon> Perfis autorizados a mover
          </span>
          <app-select-pesquisavel [control]="perfilControl(d.etapa.idEtapaKanban)" label="Todos os perfis podem mover"
            hint="Lista vazia = todos os perfis podem mover." [offlineList]="data.perfis" idField="idPerfil"
            nameField="nome" [multiple]="true" [showBadges]="true" subscriptSizing="dynamic">
          </app-select-pesquisavel>
        </div>
        }
      </div>
      }
    </div>
    }

    <app-alert-card type="info">{{ notaGrade }}</app-alert-card>
  </section>

  <!-- 5. Motivo obrigatório -->
  <section class="kb-secao">
    <div class="section-title">
      <span class="status-badge badge-cinza">5</span>
      <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
      <span>Motivo obrigatório</span>
    </div>
    <p class="section-sub-title">Peça uma justificativa sempre que um card entrar nesta etapa.</p>

    <!-- Padrão do design system (ver Devoluções de Vendas): switch à esquerda do rótulo,
         dentro do próprio mat-slide-toggle; texto de apoio abaixo, indentado sob o rótulo. -->
    <div class="toggle-content">
      <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="isMotivoObrigatorio">
        Exigir informação ao entrar nesta etapa
      </mat-slide-toggle>
      <span class="info-text">Ao mover um card para esta etapa, o usuário deverá selecionar um motivo antes de
        confirmar.</span>
    </div>

    @if (isMotivoObrigatorio) {
    <!-- Caixa com borda própria (protótipo) — mesmo padrão da caixa de Cor/Ícone da Identidade. -->
    <div class="motivos-bloco">
      <span class="motivos-bloco-label">
        <mat-icon class="material-symbols-outlined">list</mat-icon> Motivos disponíveis nesta etapa
      </span>
      <app-select-pesquisavel [control]="motivosControl" label="Todos os motivos ativos" [offlineList]="motivosOptions"
        idField="idPerfil" nameField="nome" [multiple]="true" [showBadges]="true" subscriptSizing="dynamic">
      </app-select-pesquisavel>
      <div class="motivos-rodape">
        <span class="hint">{{ resumoMotivos }}</span>
        <button type="button" class="link-gerenciar" (click)="gerenciarMotivos()">
          <mat-icon class="material-symbols-outlined">open_in_new</mat-icon> Gerenciar motivos
        </button>
      </div>
    </div>
    }
  </section>
  }

</mat-dialog-content>

<mat-dialog-actions class="modal-actions">
  <!-- Etapa fixa do sistema não pode ser excluída. -->
  @if (isEdicao && !isFixo) {
  <button mat-button class="btn-excluir" (click)="excluir()"><mat-icon
      class="material-symbols-outlined">delete</mat-icon> Excluir</button>
  }
  <span class="spacer"></span>
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="salvar()" [disabled]="isSaving">Salvar</button>
</mat-dialog-actions>
